// extracted by mini-css-extract-plugin
export default {"squad-page":"SquadPage_squad-page__UUaaK","squad-title":"SquadPage_squad-title__HkxUl"};